/* Copyright (c) 2026 Xperi. All Rights Reserved. */

/**
 * Device type categories for device detection.
 * Covers legacy mobile platforms, tablets, desktops, smart TVs,
 * streaming sticks, and game consoles.
 */
export enum DeviceType {
  Console = "console", // Game consoles: Xbox, PlayStation
  Mobile = "mobile", // Phones: iOS, Android, BlackBerry, Windows Phone, KaiOS, Symbian, etc.
  Tablet = "tablet", // Tablets: iPad, Android tablet, Kindle Fire, PlayBook
  TV = "tv", // Smart TVs: Tizen, webOS, HbbTV, Roku, Fire TV, Chromecast, etc.

  // Desktop browsers: Chrome, Safari, Firefox, Edge, Opera
  Chrome = "chrome",
  Safari = "safari",
  Firefox = "firefox",
  Edge = "edge",
  Opera = "opera",

  Unknown = "unknown" // Fallback for undetected/unsupported devices
}
